var DetailStatus;
(function (DetailStatus) {
    DetailStatus["EDIT"] = "edit";
    DetailStatus["VIEW"] = "view";
})(DetailStatus || (DetailStatus = {}));
var DetailSlot;
(function (DetailSlot) {
    DetailSlot["EDIT_ACTIONS"] = "detail-edit-actions";
    DetailSlot["FORM"] = "detail-form";
    DetailSlot["VIEW_ACTIONS"] = "detail-view-actions";
})(DetailSlot || (DetailSlot = {}));
export { DetailSlot, DetailStatus, };
//# sourceMappingURL=detail-constants.js.map